/**
* Created by lito on 2018/3/27.
*/
require('es6-promise').polyfill();

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import stringTrim from 'vux/src/tools/string/trim.js'

import store from './index'


export  {API_STATUS} from '../util/params';

import {hostapi} from '../util/params';


export function fetch(url, data, type = 'post') {
let URL = hostapi + url;

return new Promise((resolve, reject) => {

AjaxPlugin.$http({
url: URL,
method: 'post',
data: data,
timeout: 6000,
transformResponse: [function (data) {

if(typeof data=='string')
{
return JSON.parse(data);
}
return data;
}],
transformRequest: [function (data) {


let ret = 'timestamp=' + new Date().getTime() + "&";
let loginfo = store.getters.getUserInfo;
if(loginfo&&loginfo.urid)
{
ret+='urid=' + loginfo.urid + "& token="+ loginfo.token +"&";
}

for (let it in data) {
ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
}
return ret
}],
headers: {
'Content-Type': 'application/x-www-form-urlencoded'
}
}).then(response => {



resolve(response.data);
}, response => {



store.commit('updateAjaxStatus',{isAjaxfail:true});
reject('fail');
})
})

}

export function fetchUserInfo(data = {}) {
return fetch("user/userinfo", data);
}

export function joinGame(data = {}) {
return fetch("game/joingame", data);
}

export function subDetail(data = {}) {
return fetch("game/subdetail", data);
}

export function getBonus(data = {}) {
return fetch("game/getbonus", data);
}

export function getRank(data = {}) {
return fetch("api/run-rank", data);
}

export function fetchUserVerify(data) {
return fetch("user/verify", data);
}







// WEBPACK FOOTER //
// ./src/store/api.js